module.exports = __webpack_public_path__ + "img/sms-notification.a7e8f96d.svg";